// src/components/LoadingPage/LoadingPage.tsx
import React from 'react'
import { Spinner } from 'react-bootstrap'

export default function LoadingPage({ text = 'กำลังโหลด...' }: { text?: string }) {
  return (
    <div
      className='d-flex flex-column justify-content-center align-items-center'
      style={{ minHeight: '60vh', gap: 12 }}
    >
      <Spinner animation='border' variant='warning' />
      <div className='text-muted' style={{ fontSize: 14 }}>{text}</div>
    </div>
  )
}
